import { render, staticRenderFns } from "./itj.vue?vue&type=template&id=41f3ea6a"
import script from "./itj.vue?vue&type=script&lang=js"
export * from "./itj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EducatorPanel: require('/usr/src/app/components/educator/panel.vue').default})
